import { render, staticRenderFns } from "./new-signup-form.vue?vue&type=template&id=9a815e86&scoped=true"
import script from "./new-signup-form.vue?vue&type=script&lang=js"
export * from "./new-signup-form.vue?vue&type=script&lang=js"
import style0 from "./new-signup-form.vue?vue&type=style&index=0&id=9a815e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a815e86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCheckbox,VCol,VContainer,VForm,VTextField})
